import { useMemo } from 'react'
import { vinculosEspecialidadeColumns } from './columns/_columns'
import { FormularioEmpresaList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useT } from '_metronic/i18n/Metronici18n'

export const EspecialidadeVinculosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => vinculosEspecialidadeColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum vínculo encontrado'
      description={`Revise a especialidade, a ${t('empresa.label.lowercase')} ou a unidade.`}
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum vínculo cadastrado'
      description='Use “Novo vínculo” para vincular o formulário a especialidades.'
    />
  )

  return (
    <CustomTable<FormularioEmpresaList>
      id='kt_table_vinculos_especialidade'
      ariaLabel='Vínculos por especialidade'
      itemLabel={{ singular: 'vínculo', plural: 'vínculos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
